import React, { type ForwardedRef, forwardRef } from 'react';

import './TextArea.scss';
import { type TextAreaChangeEvent, type TextAreaFocusEvent } from './types';

export interface TextAreaProps {
    // TODO: Should use a uniqueId factory
    id: string;
    value?: string;
    placeholder?: string;
    maxLength?: number;
    disabled?: boolean;
    readOnly?: boolean;
    // TODO: `onInput` would be preferred, but React throws an error.
    onChange(event: TextAreaChangeEvent): void;
    onBlur?(event: TextAreaFocusEvent): void;
    onFocus?(event: TextAreaFocusEvent): void;
}

function TextAreaComponent(
    {
        id,
        value = '',
        placeholder,
        maxLength,
        disabled = false,
        readOnly = false,
        onChange,
        onBlur,
        onFocus,
    }: TextAreaProps,
    ref: ForwardedRef<HTMLTextAreaElement>,
) {
    return (
        <textarea
            ref={ref}
            id={id}
            rows={1}
            spellCheck="false"
            className="Yat-TextArea"
            value={value}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            readOnly={readOnly}
            onChange={readOnly ? undefined : onChange}
            onBlur={onBlur}
            onFocus={onFocus}
        />
    );
}

export const TextArea = forwardRef(TextAreaComponent);
